var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 16,
    viewBox: "0 0 7 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 13.0002C1.43442 13.001 1.36941 12.9881 1.30913 12.9623C1.24885 12.9364 1.19465 12.8983 1.15 12.8502C0.95 12.6502 0.95 12.3402 1.15 12.1402L5.3 7.99023L1.15 3.85023C0.95 3.65023 0.95 3.34023 1.15 3.14023C1.35 2.94023 1.66 2.94023 1.86 3.14023L6.35 7.65023C6.55 7.85023 6.55 8.16023 6.35 8.36023L1.85 12.8502C1.75 12.9502 1.62 13.0002 1.5 13.0002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrowRightBlack.e3ede3da095598eaf97eec516a7ac060.svg";
export { ForwardRef as ReactComponent };